module.exports = __webpack_public_path__ + "img/quest_icon_0009_crown.681eb297.png";